import { VStack } from '@chakra-ui/react';
import { Modal, ModalBody, ModalHeader, Button, Text } from 'components/UI';
import { gradientStyle } from 'constants/theme';
import { LinkButton } from '../Buttons/LinkButton';

type ErrorPopupProps = {
  closePopup: () => void;
  isOpen: boolean;
  message: string;
  reportUrl: string;
};

const ErrorPopup = ({ message, isOpen, reportUrl, closePopup }: ErrorPopupProps) => {
  const renderMessage = message ? (
    <Text textAlign="center" mb={8}>
      {message}
    </Text>
  ) : null;
  return (
    <Modal
      isOpen={isOpen}
      isCloseButton
      closeOnEsc={false}
      closeOnOverlayClick
      isCentered
      size="xl"
      onClose={closePopup}
    >
      <ModalHeader textAlign="center" fontSize="4xl">
        ERROR
      </ModalHeader>
      <ModalBody pb={8}>
        {renderMessage}
        <VStack mt={4}>
          <LinkButton
            href={reportUrl}
            w="full"
            buttonProps={{
              w: 'full',
            }}
            size="sm"
          >
            DOWNLOAD ERROR REPORT
          </LinkButton>
          <Button
            sx={{
              ...gradientStyle,
              _focus: {
                boxShadow: 'none',
              },
              color: 'primaryFontColour.400',
              borderStyle: 'solid',
              w: 'full',
            }}
            size="sm"
            onClick={closePopup}
          >
            CLOSE
          </Button>
        </VStack>
      </ModalBody>
    </Modal>
  );
};

export default ErrorPopup;
